/* eslint-disable import/prefer-default-export */
import { ResourceTypeEnum } from '../endpoints/services/commonHdr.service'

export class Routes {
  static readonly loginPage = '/login'
  static readonly defaultPage = '/dashboard'
  static readonly patternDetailParamsPath =
    ':tenantId/:cloudType/:accountId/:region/:type/:resourceType?/:id/'
  static readonly patternPagePath = `/:page`
  static readonly patternPath = `${Routes.patternPagePath}/${Routes.patternDetailParamsPath}`
  static readonly onlineHelpPath =
    'https://documentation.sailpoint.com/cam/help/'

  //For scopes
  static readonly patternScopeDetailParamsPath = `:tenantId/:cloudType/:accountId/:region/:type(${ResourceTypeEnum.ROLE})/:resourceType?/:id/scope/:scopeUri/`
  static readonly patternRoleScopePath = `${Routes.patternPagePath}/${Routes.patternScopeDetailParamsPath}`

  static pages = {
    dashboard: {
      path: `/dashboard`
    },
    objects: {
      path: `/objects`
    },
    identities: {
      path: `/identities`
    },
    searchResult: {
      path: `/searchresult`
    },
    compliance: {
      path: `/compliance`
    },
    guardrails: {
      path: `/guardrails`
    },
    changes: {
      path: `/changes`
    },
    alerts: {
      path: `/alerts`
    },
    setup: {
      path: `/setup`
    },
    settings: {
      path: `/settings/:id`
    },
    sources: {
      cloud: {
        path: `/sources/cloud`
      },
      path: `/sources`
    },
    privileges: {
      path: `/privileges`
    },
    publicObjects: {
      path: `/public-objects`
    },
    shadowAccess: {
      path: `/shadow-access`
    },
    unusedSAccess: {
      path: `/unused-access`
    },
    networks: {
      path: `/networks`
    },
    reports: {
      path: `/reports`
    }
  }
}
